




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class'

const StoreGeneratePdf = namespace("GeneratePdf");

@Component
export default class ModalEditWithholdingNumber extends Vue {
  private showModal: boolean = true;

  @StoreGeneratePdf.Action
  private DoUpdateShowModalGeneratePdf!: (input: boolean) => void;
  
  public HideModal() {
    this.DoUpdateShowModalGeneratePdf(false);
  }
  
  public PrintPdf() {
    this.$emit("PrintDocumentOnModal");
  }
}
